import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import styles from './DotsLoader.module.scss';

export const DotsLoader: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <Box className={styles.dotLoader}>
      <Box className={clsx(styles.dot, className)}></Box>
      <Box className={clsx(styles.dot, className)}></Box>
      <Box className={clsx(styles.dot, className)}></Box>
    </Box>
  );
};
